import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import classNames from 'classnames';

import '../css/SatelliteTab.less';
import Auth from '../managers/AuthManager';

import { SatCoreRegister } from '../SatCoreRegistry';

import ContentService from '../services/ContentService';

import { focusableElementList } from '../utils';
 

export default
@inject('contentManager', 'courseManager', 'classroomManager', 'userManager')
@observer
class SatelliteTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      leftSide: true,
      tabOpen: false,
    };

    this.contentPanelRef = React.createRef();
  }

  async componentDidMount() {
    window.removeEventListener('message', this.handleMessage);
    window.addEventListener('message', this.handleMessage);
    
    // Check initial state and notify iframe if conditions are met
    this.notifyIframeButtonVisibility(false,false);
  }
  
  notifyIframeButtonVisibility = (show = null,  open = null) => {
  
    const { contentManager, courseManager } = this.props;
    const { lessonPlayerShowing } = contentManager;
    const shouldShowButton = show !== null ? show : (lessonPlayerShowing && 
                             courseManager.relatedContentElementList && 
                             courseManager.relatedContentElementList.length > 0);
    
    const iframe = document.getElementById('fulldialog-frame');
    if (iframe && iframe.contentWindow) {
      console.log('notifying iframe button visibility', shouldShowButton);
      console.log('open', open);
      iframe.contentWindow.postMessage({
        type: 'related_tab_button_visibility',
        show: shouldShowButton,
        open: open
      }, Auth.lesson);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleMessage);
  }

  handleMessage = async (event) => {
    const { courseManager, userManager, classroomManager } = this.props;
    const { isStudent } = userManager;

    // clear out the related linked content element list. this sometimes shows, releated content always shows.
    await courseManager.setRelatedLinkedContentElementList([]);
    if (event.origin === Auth.lesson && event.data.type && event.data.type === 'current_elements' && !isStudent) {
      ContentService.setSatelliteTabShowing(false);
      this.notifyIframeButtonVisibility(false,false);
      await courseManager.viewRealatedContent(event.data.lessonElementIds, classroomManager.currentClassroomId);
      if (courseManager.relatedContentElementList && courseManager.relatedContentElementList.length > 0) {
        ContentService.setSatelliteTabShowing(true);
        const {tabOpen} = this.state;
        this.notifyIframeButtonVisibility(true,tabOpen);
      }
    }

    // Dedicated satellite tab control messages
    if (event.origin === Auth.lesson && event.data.type && event.data.type === 'open_satellite') {
      ContentService.setSatelliteTabShowing(true);
      this.setState({ tabOpen: true }, () => {
        if (this.contentPanelRef.current) {
          const firstFocusable = this.contentPanelRef.current.querySelector(focusableElementList);
          firstFocusable?.focus();
        }
      });
    }

    if (event.origin === Auth.lesson && event.data.type && event.data.type === 'close_satellite') {
      ContentService.setSatelliteTabShowing(false);
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ tabOpen: false });
    }

    if (event.origin === Auth.lesson && event.data.type && event.data.type === 'linked_element' && !isStudent) {
      const { foreverId } = event.data;

      // Find matching element in relatedContentElementList
      const matchingElement = courseManager.relatedContentElementList.find(
        (relatedElement) => relatedElement.contentItemForeverId === foreverId
      );

      if (matchingElement) {
        // Populate relatedLinkedContentElementList with the matching element
        courseManager.setRelatedLinkedContentElementList([matchingElement]);
        ContentService.setSatelliteTabShowing(true);
        this.notifyIframeButtonVisibility(true,true);
        // Open the satellite tab programmatically (no button)
        this.setState({ tabOpen: true }, () => {
          if (this.contentPanelRef.current) {
            const firstFocusable = this.contentPanelRef.current.querySelector(focusableElementList);
            firstFocusable?.focus();
          }
        });
      }
    }
    if (event.origin === Auth.lesson && event.data.type && event.data.type === 'access_assignments' && isStudent) {
      ContentService.setSatelliteTabShowing(event.data.previousAssignments);
      this.notifyIframeButtonVisibility(event.data.previousAssignments,false);
    }
  }

  
  // Ensure tab closes when visibility is turned off
  componentDidUpdate(prevProps) {
    const { contentManager, courseManager } = this.props;
    if (!contentManager.satelliteTabShowing && prevProps.contentManager.satelliteTabShowing) {
      // hide tab when visibility is disabled and reset open state
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ tabOpen: false });
    }
  }

  render() {
    const { additionalClassName = '', ChildComponent, tabName, contentManager, courseManager, userManager } = this.props;
    const { lessonPlayerShowing } = contentManager;
    const { isStudent } = userManager;
    const { leftSide, tabOpen } = this.state;

    let satelliteTabClassName = 'satelliteTab';
    satelliteTabClassName += additionalClassName ? ` ${additionalClassName}` : '';

    // Visibility controlled by contentManager.satelliteTabShowing

    if (!isStudent && ChildComponent !== null && ChildComponent !== undefined &&
      lessonPlayerShowing && (courseManager.relatedContentElementList && courseManager.relatedContentElementList.length > 0) && contentManager.satelliteTabShowing) {
      return (
        <div className={classNames({ left: leftSide, open: tabOpen }, satelliteTabClassName)}>
          <div ref={this.contentPanelRef} className={classNames('contentPanel', 'relatedContent')}>
            <ChildComponent />
          </div>
          
        </div>
      );
    }
    if (isStudent && ChildComponent !== null && ChildComponent !== undefined && lessonPlayerShowing && contentManager.satelliteTabShowing) {
      return (
        <div className={classNames({ left: leftSide, open: tabOpen }, satelliteTabClassName)}>
          <div ref={this.contentPanelRef} className={classNames('contentPanel', 'pastAssignments')}>
            <ChildComponent />
          </div>
          
        </div>
      );
    }

    return (
      <></>
    );
  }
}

SatCoreRegister('SatelliteTab', SatelliteTab);
